enum StorageKey {
  AddressVerificationBannerDismissed = 'address_verification_banner_dismissed',
  AddressVerificationBannerFirstSeen = 'address_verification_banner_first_seen',
  AddressVerificationToastDismissed = 'address_verification_toast_dismissed',
  AddressVerificationProTipDismissed = 'address_verification_pro_tip_dismissed',
}

const getStorageKey = (
  environment: string,
  key: StorageKey,
  appId?: string,
): string => {
  return appId ? `${environment}_${key}_${appId}` : `${environment}_${key}`;
};

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

export const addressVerificationStorage = {
  isBannerDismissed: (environment: string, appId: string): boolean => {
    return (
      localStorage.getItem(
        getStorageKey(
          environment,
          StorageKey.AddressVerificationBannerDismissed,
          appId,
        ),
      ) === 'true'
    );
  },

  setBannerDismissed: (environment: string, appId: string): void => {
    localStorage.setItem(
      getStorageKey(
        environment,
        StorageKey.AddressVerificationBannerDismissed,
        appId,
      ),
      'true',
    );
  },

  initializeBannerFirstSeen: (environment: string, appId: string): void => {
    const firstSeenKey = getStorageKey(
      environment,
      StorageKey.AddressVerificationBannerFirstSeen,
      appId,
    );
    if (!localStorage.getItem(firstSeenKey)) {
      localStorage.setItem(firstSeenKey, Date.now().toString());
    }
  },

  getBannerFirstSeen: (environment: string, appId: string): number => {
    const firstSeenAt = localStorage.getItem(
      getStorageKey(
        environment,
        StorageKey.AddressVerificationBannerFirstSeen,
        appId,
      ),
    );
    return firstSeenAt ? parseInt(firstSeenAt, 10) : 0;
  },

  shouldShowBanner: (environment: string, appId: string): boolean => {
    if (addressVerificationStorage.isBannerDismissed(environment, appId)) {
      return false;
    }

    const firstSeenAt = addressVerificationStorage.getBannerFirstSeen(
      environment,
      appId,
    );
    if (!firstSeenAt) {
      return true;
    }

    const now = Date.now();
    return now - firstSeenAt <= THREE_DAYS_MS;
  },

  isToastDismissed: (environment: string, appId: string): boolean => {
    return (
      localStorage.getItem(
        getStorageKey(
          environment,
          StorageKey.AddressVerificationToastDismissed,
          appId,
        ),
      ) === 'true'
    );
  },

  setToastDismissed: (environment: string, appId: string): void => {
    localStorage.setItem(
      getStorageKey(
        environment,
        StorageKey.AddressVerificationToastDismissed,
        appId,
      ),
      'true',
    );
  },

  isProTipDismissed: (environment: string, appId: string): boolean => {
    return (
      localStorage.getItem(
        getStorageKey(
          environment,
          StorageKey.AddressVerificationProTipDismissed,
          appId,
        ),
      ) === 'true'
    );
  },

  setProTipDismissed: (environment: string, appId: string): void => {
    localStorage.setItem(
      getStorageKey(
        environment,
        StorageKey.AddressVerificationProTipDismissed,
        appId,
      ),
      'true',
    );
  },
};
